import React from 'react';
import { MessageSquareText, Map, User, Briefcase } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { AppSection } from './MainLayout';

interface Props {
  activeSection: AppSection;
  setActiveSection: (section: AppSection) => void;
}

const MobileNavButton: React.FC<{ active: boolean; onClick: () => void; icon: React.ReactNode; label: string }> = ({ active, onClick, icon, label }) => {
    const { theme } = useTheme();
    return (
        <button
            onClick={onClick}
            className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 ${
            active ? theme.colors.text.accent : theme.colors.text.secondary
            }`}
        >
            <div className={`p-1.5 rounded-xl transition-all duration-300 ${active ? (theme.mode === 'dark' ? 'bg-slate-800 shadow-sm' : 'bg-indigo-50 shadow-sm') : 'bg-transparent'}`}>
            {icon}
            </div>
            <span className="text-[10px] font-bold">{label}</span>
        </button>
    );
};

export const MobileNav: React.FC<Props> = ({ activeSection, setActiveSection }) => {
    const { theme } = useTheme();

    return (
        <nav className={`md:hidden fixed bottom-0 left-0 right-0 border-t flex justify-around p-2 z-30 pb-safe backdrop-blur-md ${theme.components.sidebar.container}`}>
            <MobileNavButton 
                active={activeSection === 'chat'} 
                onClick={() => setActiveSection('chat')} 
                icon={<MessageSquareText size={20} />} 
                label="Chat"
            />
            <MobileNavButton 
                active={activeSection === 'insights'} 
                onClick={() => setActiveSection('insights')} 
                icon={<Briefcase size={20} />} 
                label="Insights"
            />
            <MobileNavButton 
                active={activeSection === 'journey'} 
                onClick={() => setActiveSection('journey')} 
                icon={<Map size={20} />} 
                label="Journey"
            />
            <MobileNavButton 
                active={activeSection === 'profile'} 
                onClick={() => setActiveSection('profile')} 
                icon={<User size={20} />} 
                label="Profile"
            />
        </nav>
    );
};